/* eslint-disable */
// /src/services/storeProfileService.js

import { doc, getDoc, setDoc, deleteDoc, serverTimestamp } from "firebase/firestore";

import { db } from "./firebase";

const COL_PROFILES = "store_order_profiles";

/**
 * 기본 주문/배송 프로필 조회
 * - 문서 ID = phoneE164
 * - 없으면 null 반환
 */
export async function getDefaultOrderProfile(phoneE164) {
    if (!phoneE164) return null;
    try {
        const ref = doc(db, COL_PROFILES, phoneE164);
        const snap = await getDoc(ref);
        if (!snap.exists()) return null;

        const data = snap.data() || {};
        return {
            orderer: {
                name: data.orderer?.name || "",
                phone: data.orderer?.phone || "",
                email: data.orderer?.email || "",
                zip: data.orderer?.zip || "",
                addr1: data.orderer?.addr1 || "",
                addr2: data.orderer?.addr2 || "",
            },
            // receiver는 선택사항: 없으면 orderer와 동일하게 쓸 수도 있음
            receiver: data.receiver
                ? {
                    name: data.receiver?.name || "",
                    phone: data.receiver?.phone || "",
                    zip: data.receiver?.zip || "",
                    addr1: data.receiver?.addr1 || "",
                    addr2: data.receiver?.addr2 || "",
                }
                : null,
        };
    } catch (e) {
        console.error("[storeProfileService] getDefaultOrderProfile error", e);
        return null;
    }
}

/**
 * 기본 주문/배송 프로필 저장
 * - profile: { orderer, receiver? }
 * - orderer 필드는 필수(name/phone/주소 등)
 */
export async function saveDefaultOrderProfile(phoneE164, profile) {
    if (!phoneE164) {
        throw new Error("phoneE164 is required");
    }
    if (!profile || !profile.orderer) {
        throw new Error("profile.orderer is required");
    }

    const orderer = profile.orderer || {};
    const receiver = profile.receiver || null;

    const payload = {
        orderer: {
            name: (orderer.name || "").trim(),
            phone: (orderer.phone || "").trim(),
            email: (orderer.email || "").trim(),
            zip: (orderer.zip || "").trim(),
            addr1: (orderer.addr1 || "").trim(),
            addr2: (orderer.addr2 || "").trim(),
        },
        updatedAt: serverTimestamp(),
    };

    if (receiver) {
        payload.receiver = {
            name: (receiver.name || "").trim(),
            phone: (receiver.phone || "").trim(),
            zip: (receiver.zip || "").trim(),
            addr1: (receiver.addr1 || "").trim(),
            addr2: (receiver.addr2 || "").trim(),
        };
    }

    try {
        const ref = doc(db, COL_PROFILES, phoneE164);
        await setDoc(ref, payload, { merge: true });
    } catch (e) {
        console.error("[storeProfileService] saveDefaultOrderProfile error", e);
        throw e;
    }
}

/**
 * 기본 주문/배송 프로필 삭제
 * - 이후 주문 페이지 들어가면 빈 값으로 시작
 */
export async function clearDefaultOrderProfile(phoneE164) {
    if (!phoneE164) return;
    try {
        const ref = doc(db, COL_PROFILES, phoneE164);
        await deleteDoc(ref);
    } catch (e) {
        console.error("[storeProfileService] clearDefaultOrderProfile error", e);
        throw e;
    }
}
